// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1HOKm","header":"MergedInvoice_header__35QzV"};